import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";

export default function AdminStudentMappingPage({
  bulkMappingData,
  setBulkMappingData,
  fetchMappingBatches,
  centersList,
  mappingBatches,
  selectedStudentIds,
  unassignedStudents,
  handleSelectAllUnassigned,
  toggleStudentSelection,
  handleBulkAssignStudents,
}) {
  return (
    <Card className="shadow-lg">
      <CardHeader className="border-b">
        <CardTitle className="text-lg">Student Mapping</CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="space-y-2">
            <Label>Target Center</Label>
            <select
              className="w-full h-10 px-3 rounded-md border border-slate-300 bg-white"
              value={bulkMappingData.centerId}
              onChange={(event) => {
                const centerId = event.target.value;
                setBulkMappingData({ centerId, batchId: "" });
                fetchMappingBatches(centerId);
              }}
            >
              <option value="">-- Select a Center --</option>
              {centersList.map((center) => (
                <option key={center.id} value={center.id}>
                  {center.name}
                </option>
              ))}
            </select>
          </div>
          <div className="space-y-2">
            <Label>Target Batch</Label>
            <select
              className="w-full h-10 px-3 rounded-md border border-slate-300 bg-white"
              value={bulkMappingData.batchId}
              onChange={(event) => setBulkMappingData({ ...bulkMappingData, batchId: event.target.value })}
              disabled={!bulkMappingData.centerId}
            >
              <option value="">-- Select a Batch --</option>
              {mappingBatches.map((batch) => (
                <option key={batch.id} value={batch.id}>
                  {batch.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-slate-700">Unassigned Students</p>
          <Button type="button" variant="outline" size="sm" onClick={handleSelectAllUnassigned}>
            {selectedStudentIds.length === unassignedStudents.length && unassignedStudents.length > 0 ? "Clear" : "Select All"}
          </Button>
        </div>

        <div className="space-y-2 max-h-80 overflow-y-auto">
          {unassignedStudents.length === 0 ? (
            <p className="text-sm text-slate-500">No unassigned students found.</p>
          ) : (
            unassignedStudents.map((student) => (
              <label key={student.id} className="flex items-start gap-3 rounded-lg border border-slate-200 bg-slate-50 p-3 cursor-pointer">
                <input
                  type="checkbox"
                  className="mt-1"
                  checked={selectedStudentIds.includes(student.id)}
                  onChange={() => toggleStudentSelection(student.id)}
                />
                <div>
                  <p className="font-medium text-slate-900">{student.name}</p>
                  <p className="text-sm text-slate-500">Coach: {student.coach_id}</p>
                  <p className="text-xs text-slate-500">DOB: {student.dob || "Not set"}</p>
                </div>
              </label>
            ))
          )}
        </div>

        <Button className="w-full bg-slate-900 hover:bg-black" onClick={handleBulkAssignStudents}>
          Map Selected Students
        </Button>
      </CardContent>
    </Card>
  );
}